import styled from "@emotion/styled";
import { fontRoboto, fontRobotoCondensed } from "@product/scmp-sdk";

export const Container = styled.div`
  margin-block-end: 28px;

  ${props => props.theme.breakpoints.only("tablet")} {
    margin-inline-end: 7px;
  }
  ${props => props.theme.breakpoints.up("desktop")} {
    margin-inline-end: 8px;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;

  margin-block: 0 12px;
  margin-inline: 16px;
`;

export const Title = styled.div`
  color: #001246;
  font-size: 20px;
  font-family: ${fontRobotoCondensed};
  line-height: 24px;
`;

export const SelectAllContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  align-items: center;

  cursor: pointer;
`;
export const SelectAllLabel = styled.span`
  margin-inline-end: 8px;

  color: #4585ff;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
`;
